import React from "react";
import FAQSection from "../components/FAQ/FAQSection";
import FAQHero from "../components/FAQ/FAQHero";

const FAQ = () => {
  return (
    <div>
      <FAQHero />
      <FAQSection />
    </div>
  );
};

export default FAQ;
